import { writable } from 'svelte/store';

const create_unlocked_store = () => {
	const { subscribe, set, update } = writable({});

	return {
		subscribe,
		unlock_device: (device, time = Date.now()) => {
			update((ids) => {
				ids[device.id] = time;
				return ids;
			});
		},
		remove_device: (device) => {
			update((ids) => {
				delete ids[device.id];
				return ids;
			});
		},
		reset: () => set({}),
	};
};
export const pin_unlocked_devices = create_unlocked_store();
